module.exports = __webpack_public_path__ + "./img/PedidosInicio.d4919fddea1713de38111550f4e4d147.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/PedidosInicio.png
// module id = ./public/img/Help/PedidosInicio.png
// module chunks = 0